import { render, staticRenderFns } from "./ImpactHero.vue?vue&type=template&id=64cdffaf&scoped=true"
import script from "./ImpactHero.vue?vue&type=script&lang=js"
export * from "./ImpactHero.vue?vue&type=script&lang=js"
import style0 from "./ImpactHero.vue?vue&type=style&index=0&id=64cdffaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cdffaf",
  null
  
)

export default component.exports